// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import moment from 'moment';
import DatePicker from 'react-datepicker';

class CourtBookingList extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    // const game = params.get('game_type')
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      start_date:moment(),
      end_date:moment(),
      customer_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      date_changed: false
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getCustomers(this.state.venue,this.state.start_date,this.state.end_date);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getCustomers(this.state.venue,this.state.start_date,this.state.end_date) 
    })
  }

  getCustomers(venue,start_date,end_date) {
    var start = moment(start_date).format("YYYY-MM-DD")
    var end = moment(end_date).format("YYYY-MM-DD")

    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=75475&venue_id=${venue}&date=${start}&end_date=${end}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,headers:data.headers, date_changed:false})
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  handleStartDate(date) {
    this.setState({start_date:date,date_changed:true})
    this.getCustomers(this.state.venue,date,this.state.end_date)
  }

  handleEndDate(date) {
    this.setState({end_date:date,date_changed:true})
    this.getCustomers(this.state.venue,this.state.start_date,date)
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  renderCutsomers(){
   
    var headers = []
    if(this.state.customer_data.length > 0){
      headers = Object.keys(this.state.customer_data[0])
    }
    
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive'>
        <div className="heading heading2 left">Court Booking List</div> 
        <div className='col-md-6' style={styles.date}>
          <div className='col-md-3' style={{padding:'0px',marginRight:'20%'}}>
            <div style={{fontWeight:'bold'}}> From - </div>
            <DatePicker selected={this.state.start_date} onChange={this.handleStartDate} style={{marginRight:'3%'}}/>
          </div>
          <div className='col-md-3' style={{padding:'0px'}}>
            <div style={{fontWeight:'bold'}}> To - </div>
            <DatePicker selected={this.state.end_date} onChange={this.handleEndDate}/>
          </div>
        </div>

        { this.state.headers.length > 0 && !this.state.date_changed ?
          <ReactTable  
                      data={this.state.customer_data}  
                      columns={headings}  
                      defaultPageSize = {25}  
                      pageSizeOptions = {[25,50,75,100]} 
                      filterable={true}
                      showPagination={this.state.customer_data.length > 25}
                      showPaginationTop = {this.state.customer_data.length > 25}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          />
          :
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
        }
      </div>
      )
  }

  render() {
    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('customer_data',this.state.customer_data)
    return(
      <div>
        
        <div>
          <div className="breadcrumps" style={{marginBottom:'1%'}}>
            <a href={'/#/partnerCourtBooking'}>
              <span>Rental</span>
            </a> 
            <a >
              <span>Court Booking List</span>
            </a> 
          </div>
          {this.renderCutsomers()}
        </div>
      </div>
    );
  }
}

export default CourtBookingList;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/courtBookingList/CourtBookingList.js